/*
 * BuildDocs пользовательский интерфейс version 0.1.0
 *
 * Copyright © 2021 ООО АДАПТ info@acfs.spb.ru
 * You may use, distribute and modify this code under the
 * terms of the ООО АДАПТ license
 */

type Params = {
  actStatus?: string
  documentType: string
  field: string
  modificationAllowed?: boolean
}

export const isDocumentFieldDisabled = ({
  actStatus,
  documentType,
  field,
  modificationAllowed,
}: Params) => {
  const isActEditable = actStatus === 'NEW' || actStatus === 'RECREATED'

  const canEditProjectSheet =
    documentType === 'WORKING_DRAFT' && field === 'sheet'

  return (
    !canEditProjectSheet &&
    (documentType === 'EXECUTIVE_DRAWING' ||
      modificationAllowed === false ||
      !isActEditable)
  )
}
